// import { getListBooking } from "@/api/booking";
import { defineStore } from "pinia";
import {
  getListAllotment,
  updateAllotment,
  getAllotmentDetail,
  updateAllotmentDetail,
  blockAllotment,
  getListAllotmentSetter,
  createAllotment,
  unBlockAllotment,
  getListHistoryAllotment,
  getMergeAllotment,
  getListBlockRequest,
  requestBlockAllotment,
  getBlockRequestDetail,
  withdrawBlockRequest,
} from "@/api/allotment";
import { transformDateKeys } from "@/utils/dateTime.util";
import { format } from "date-fns";

import { ALLOTMENT_DAYS } from "@/config/allotment.config";

export const useAllotmentStore = defineStore({
  id: "allotment",
  state: () => ({
    bookingDays: ALLOTMENT_DAYS,
    allTimeInDays: [],
    allotmentSetter: null,
    allotsData: {},
    allotments: [],
    // alotmentDetails: null,
    showAllotmentDetails: null,
    allotmentDetails: [],
    zoomable: {
      scale: 1,
      transformOrigin: "center center",
      scrollX: 0,
      scrollY: 0,
    },
    historyAllotments: [],
    pagination: {},
    selectedPackages: [],
    shouldUpdate: false,
    blockRequestList: [],
    blockRequestPagination: {},
  }),
  getters: {
    getBookingDays: (state) => state.bookingDays,
  },
  actions: {
    resetBookingDays() {
      this.bookingDays = ALLOTMENT_DAYS;
    },
    applyFirstDayToAll() {
      const receiveBookingDaysValue = this.bookingDays;
      const firstDaySetting = receiveBookingDaysValue[0];

      const copyFromFirstTime = {
        closed: firstDaySetting.closed,
        firstBookingTime: firstDaySetting.firstBookingTime,
        lastBookingTime: firstDaySetting.lastBookingTime,
        seatAvailable: firstDaySetting.seatAvailable,
      };

      const newValue = [firstDaySetting];
      for (let i = 1; i < this.bookingDays.length; i++) {
        const subTimes = firstDaySetting.subTimes.map((time) => {
          return {
            ...time,
            dayId: this.bookingDays[i].id,
            id: Math.floor(Math.random() * (new Date().getTime() - 0 + 1) + 0),
            label: this.bookingDays[i].label,
          };
        });
        const firstTimeClonse = {
          ...this.bookingDays[i],
          ...copyFromFirstTime,
          subTimes,
        };

        newValue.push(firstTimeClonse);
      }

      this.bookingDays = newValue;
    },
    closeReceiveBookingTime(id, status, subId = null) {
      const receiveBookingDays = this.bookingDays;
      const indexById = receiveBookingDays.findIndex((item) => item.id === id);
      if (!subId) {
        this.bookingDays[indexById].closed = status;
        return;
      }

      const indexBySubId = this.bookingDays[indexById].subTimes.findIndex(
        (item) => item.id === subId,
      );

      if (indexBySubId < 0) return;
      this.bookingDays[indexById].subTimes[indexBySubId].closed = status;
    },
    getListAllotments(payload) {
      return new Promise((resolve, reject) => {
        getListAllotment(payload)
          .then(async (response) => {
            const data = response;
            if (data && typeof data === "object") {
              Object.keys(data).forEach((key) => {
                if (key.match(/^\d{2}:\d{2}$/)) {
                  // Check if the key is in HH:MM format
                  data[key].isOpen = false; // Add the `isOpen` attribute
                }
              });
              this.allotsData = transformDateKeys(data);
            }
            resolve(transformDateKeys(data));
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    createAllotment(payload) {
      return new Promise((resolve, reject) => {
        createAllotment(payload)
          .then((response) => {
            if (response?.success === false) {
              reject(response);
              return;
            }
            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updateAllotment(payload) {
      return new Promise((resolve, reject) => {
        updateAllotment(payload)
          .then((response) => {
            if (response?.success === false) {
              reject(response);
              return;
            }
            // this.getListBookingDays();
            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getAllotmentDetail({ id, restaurantId }) {
      return new Promise((resolve, reject) => {
        getAllotmentDetail({ id, restaurantId })
          .then((response) => {
            if (response?.success === false) {
              reject(response);
              return;
            }
            // this.alotmentDetails = response.data;
            const attributes = {
              id: id,
              restaurantId: restaurantId,
              ...response.data.attributes,
            };
            resolve(attributes);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updateAllotmentDetail(payload) {
      return new Promise((resolve, reject) => {
        updateAllotmentDetail(payload)
          .then((response) => {
            if (response?.success === false) {
              reject(response);
              return;
            }
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    blockAllotment(payload) {
      return new Promise((resolve, reject) => {
        blockAllotment(payload)
          .then((response) => {
            if (response?.success === false) {
              reject(response);
              return;
            }
            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getListAllotmentSetter(payload) {
      return new Promise((resolve, reject) => {
        getListAllotmentSetter(payload)
          .then((response) => {
            if (response?.success === false) {
              reject(response);
              return;
            }
            this.allotmentSetter = response.data;
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    unBlockAllotment(payload) {
      return new Promise((resolve, reject) => {
        unBlockAllotment(payload)
          .then((response) => {
            if (response?.success === false) {
              reject(response);
              return;
            }
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getListHistoryAllotment(payload) {
      return new Promise((resolve, reject) => {
        getListHistoryAllotment(payload)
          .then((response) => {
            if (response?.success === false) {
              reject(response);
              return;
            }

            const dataFormat = response.data.map((item) => {
              return {
                id: item.id,
                startDate: item.attributes.startDate
                  ? format(new Date(item.attributes.startDate), "yyyy-MM-dd")
                  : "",
                startTime: item.attributes.startTime,
                endDate: item.attributes.endDate
                  ? format(new Date(item.attributes.endDate), "yyyy-MM-dd")
                  : "",
                endTime: item.attributes.endTime,
                createdAt: item.attributes.createdAt
                  ? format(new Date(item.attributes.createdAt), "dd/MM/yyyy HH:mm")
                  : "",
                quantityAvailable: item.attributes.quantityAvailable,
                reason: item.attributes.reason ?? "-",
                serviceType: item.attributes.serviceType,
                branchName: item.attributes.restaurantName,
                restaurantId: item.attributes.restaurantId,
              };
            });

            this.historyAllotments = dataFormat;
            this.pagination = response.meta ?? null;

            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getMergeAllotment(payload) {
      return new Promise((resolve, reject) => {
        getMergeAllotment(payload)
          .then((response) => {
            if (response?.success === false) {
              reject(response);
              return;
            }
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getListBlockRequest(payload) {
      return new Promise((resolve, reject) => {
        getListBlockRequest(payload)
          .then((response) => {
            if (response?.success === false) {
              reject(response);
              return;
            }

            const dataFormat = response.data.map((item) => {
              return {
                id: item.id,
                startDate: item.attributes.startDate
                  ? format(new Date(item.attributes.startDate), "yyyy-MM-dd")
                  : "",
                startTime: item.attributes.startTime,
                endDate: item.attributes.endDate
                  ? format(new Date(item.attributes.endDate), "yyyy-MM-dd")
                  : "",
                endTime: item.attributes.endTime,
                createdAt: item.attributes.createdAt
                  ? format(new Date(item.attributes.createdAt), "dd/MM/yyyy HH:mm")
                  : "",
                quantityAvailable: item.attributes.quantityAvailable || "-",
                reason: item.attributes.reason ?? "-",
                serviceType: item.attributes.serviceType,
                branchName: item.attributes.restaurantName,
              };
            });

            this.blockRequestList = dataFormat;
            this.blockRequestPagination = response.meta ?? null;

            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getBlockRequestDetail(id) {
      return new Promise((resolve, reject) => {
        getBlockRequestDetail(id)
          .then((response) => {
            if (response?.success === false) {
              reject(response);
              return;
            }
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    requestBlockAllotment(payload) {
      return new Promise((resolve, reject) => {
        requestBlockAllotment(payload)
          .then((response) => {
            if (response?.success === false) {
              reject(response);
              return;
            }
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    withdrawBlockRequest(id) {
      return new Promise((resolve, reject) => {
        withdrawBlockRequest(id)
          .then((response) => {
            if (response?.success === false) {
              reject(response);
              return;
            }
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
});
